import axiosInstance from './AxiosInstance';

const API_URL = 'awardtypes';

export const getAwardtypes = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching awardtypes', error);
        throw error;
    }
};



export const getAwardtypesByCategory = async (category='normal') => {
    try {
        const response = await axiosInstance.get(`${API_URL}/${category}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching awardtypes by category', error);
        throw error;
    }
};
export const getAwardtypeById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching awardtype with id ${id}`, error);
        throw error;
    }
};

export const createAwardtype = async (awardtype) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, awardtype);
        return response.data;
    } catch (error) {
        console.error('Error creating awardtype', error);
        throw error;
    }
};

export const updateAwardtype = async (id, awardtype) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...awardtype });
        return response.data;
    } catch (error) {
        console.error(`Error updating awardtype with id ${id}`, error);
        throw error;
    }
};

export const deleteAwardtype = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting awardtype with id ${id}`, error);
        throw error;
    }
};

